import { render, staticRenderFns } from "./addUpdHomb.vue?vue&type=template&id=8cace24e&scoped=true"
import script from "./addUpdHomb.vue?vue&type=script&lang=js"
export * from "./addUpdHomb.vue?vue&type=script&lang=js"
import style0 from "./addUpdHomb.vue?vue&type=style&index=0&id=8cace24e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cace24e",
  null
  
)

export default component.exports